import React, { useState } from 'react';
import { Alert, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const DISMISS_KEY = 'email_verification_banner_dismissed';

const EmailVerificationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { user, isAuthenticated } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true'
  );
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  if (!isAuthenticated || !user || user.email_verified_at || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await api.post('/api/v1/auth/send-verification-email', { email: user.email });
      setResent(true);
    } catch {
      // тихо игнорираме - потребителят може да опита пак от /verify-email
    } finally {
      setResending(false);
    }
  };

  return (
    <Alert
      severity="warning"
      onClose={handleDismiss}
      sx={{ borderRadius: 0 }}
      action={
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Button
            size="small"
            onClick={handleResend}
            disabled={resending || resent}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {resent
              ? t('verify_email.resend_success_short')
              : resending
              ? t('common.loading')
              : t('verify_email.resend_button')}
          </Button>
          <Button
            size="small"
            component={RouterLink}
            to="/verify-email"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {t('verify_email.verify_button')}
          </Button>
        </Box>
      }
    >
      {t('verify_email.banner_message')}
    </Alert>
  );
};

export default EmailVerificationBanner;
